export const FETCH_WECHAT_ARTICLE = 'FETCH_WECHAT_ARTICLE';
export const FETCH_WECHAT_ARTICLE_SUCCESS = 'FETCH_WECHAT_ARTICLE_SUCCESS';

export const fetchWechatArticle = (data) => ({
  type: FETCH_WECHAT_ARTICLE,
  data
})

export const fetchWechatArticleSuccess = (data) => ({
  type: FETCH_WECHAT_ARTICLE_SUCCESS,
  data,
})



/** WEBPACK FOOTER **
 ** ./src/app/modules/carousel/actions.js
 **/